<script>
import ContactUsImage from "../contact/contactUsImage.vue";
import FooterSection from "../package/footerSection.vue";
import GotQuestions from "../package/gotQuestions.vue";
import SocialSection from "../package/socialSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";
import BreadcrumbLogin from "./breadcrumbLogin.vue";
import HeaderSection from "../package/HeaderSection.vue";
import AgentSignInSection from "../package/agentSignInSection.vue";
import SignInSection from "./signInSection.vue";
import DrawerAside from "../package/DrawerAside.vue";

export default {
  name: "loginLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Login";
  },
  created() {
    document.title = "UNIFI Property: Login";
  },
  methods: {
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    }
  },
  components: {
    HeaderSection,
    SignInSection,
    AgentSignInSection,
    BreadcrumbLogin,
    propertyIconSet,
    SocialSection,
    GotQuestions,
    FooterSection,
    ContactUsImage,
    DrawerAside,
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <!--      <drawer-aside :unfold="unfold"/>-->
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-login />
        <sign-in-section />
        <agent-sign-in-section />
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
  //background-color: #2D2D2D;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/login/loginLayout.vue